import { isNotDefined } from '@sgme/fp';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { NewAmountInput } from 'components/shared/NewAmountInput';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

interface OwnProps {
  notional?: number | null;
  currency?: string;
  isDisabled: boolean;
  isLoading: boolean;
  onChange: (newNotional: number | null) => void;
}
export const TradeAllocationNotional: FC<OwnProps> = ({ notional, currency, isDisabled, isLoading, onChange }) => {
  return (
    <BlockOrientationFormGroup inputId="tradeAllocationNotionalAmount" label="tradeAllocation.edit.notional">
      {isLoading && <NotionalSkeleton />}
      {!isLoading && (
        <NewAmountInput
          id="tradeAllocationNotionalAmount"
          placeholderKey={'notional' as any}
          value={notional ?? null}
          onValueChanged={onChange}
          precision={4}
          currency={currency!}
          hasError={!isDisabled && isNotDefined(notional)}
          e2e="notional-input"
          decimalPadding={false}
          isDisabled={isDisabled}
        />
      )}
    </BlockOrientationFormGroup>
  );
};

export const NotionalSkeleton: FC = () => (
  <div className="with-unit-component input-group" data-e2e="NotionalAmount-with-unit">
    <span className="text-secondary">
      <Skeleton width="1em" />
    </span>
    <div className="form-control text-end">
      <Skeleton width="5em" />
    </div>
  </div>
);

TradeAllocationNotional.displayName = 'TradeAllocationNotional';
